import { action, computed, makeObservable, observable, toJS } from 'mobx';
import { TUser } from 'types/user/user';

import { CurrentUserResponse } from '@api/responseModels/user/currentUserResponse';
import { CRMAPIManager } from '@classes/crmApiManager';
import { messageService } from '@classes/messageService';
import { rootStore } from '@store/rootStore/instanse';

import storeLocalStorage from '../hooks/storeLocalStorage';

class CurrentUserStore {
    public user: TUser | object = {};

    constructor() {
        makeObservable(this, {
            user: observable,
            setUser: action,
            fetchCurrentUser: action,
            getUser: computed,
        });
    }

    get getUser(): TUser | null {
        const { getValue } = storeLocalStorage(this.user);
        return getValue('currentUser');
    }

    setUser(user) {
        const { setValue } = storeLocalStorage({});
        this.user = user;
        setValue('currentUser', user);
    }

    setSettingOption(settingName: string, value: any) {
        const user = this.getUser;
        const optionIndex = user?.settings?.findIndex((option) => option.name === settingName);

        if (user?.settings?.[optionIndex]) {
            user.settings[optionIndex].value = value;

            this.setUser(user);
        }
    }

    getSettingOption(settingName: string) {
        const user = this.getUser;
        return user?.settings?.find((option) => option.name === settingName)?.value;
    }

    async fetchCurrentUser() {
        try {
            const cUser = await CRMAPIManager.request<CurrentUserResponse>(async (api) => {
                return await api.getCurrentUser();
            });
            if (cUser.errorMessages) throw cUser.errorMessages;
            rootStore.currentUserStore.setUser({ ...cUser?.data?.data });
        } catch (errors) {
            messageService.sendErrorList(errors);
        }
    }
}

export { CurrentUserStore };
